import * as types from "../types";

const initialState = {
  loading: false,
  requestUser: null,
  otpData: null,
  error: null,
};

export default function preLoginReducer(state = initialState, action) {
  switch (action.type) {
    case types.PRE_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        requestUser: action.payload.requestUser,
      };

    case types.PRE_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        otpData: action.payload.otpData,
      };

    case types.PRE_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        requestUser: null,
        otpData: null,
        error: action.payload.error,
      };

      case types.PRE_LOGIN_RESET:
        return {
          ...state,
          loading: false,
          requestUser: null,
          otpData: null,
          error: null,
        };

    default:
      return state;
  }
}
